// extracted by mini-css-extract-plugin
export var measureBox = "_s-0";